
const base_url = process.env.NEXT_PUBLIC_BASE_URL

export const EDIT_USER_INFO_API = `${base_url}/api/user/update`
export const FETCH_USER_INFO_API = `${base_url}/api/user/get`
export const CHANGE_PASSWORD_API = `${base_url}/api/user/changepassword`
export const AVATAR_UPLOAD_API = `${base_url}/api/user/avatar-upload`
export const AVATAR_UPLOAD_URL = 'https://sippyappbucket.s3.amazonaws.com/'